export const SLIDE_WIDTH_IN = 16;
export const SLIDE_HEIGHT_IN = 9;
export const CM_TO_IN = 1 / 2.54;
export const PT_TO_IN = 1 / 72;
export const PX_TO_IN = 1 / 96;
export const IN_TO_PX = 96;
export const SLIDE_TITLE_TOP_IN = 0.4;
export const SLIDE_TITLE_HEIGHT_IN = 1.13;
export const SLIDE_TITLE_BOTTOM_IN = SLIDE_TITLE_TOP_IN + SLIDE_TITLE_HEIGHT_IN;
export const SLIDE_TITLE_FONT_SIZE_PT = 40;
export const SLIDE_TITLE_WIDTH_IN = 14.96;
export const SLIDE_TITLE_FONT_FAMILY = "Times New Roman";
// PowerPoint single line spacing, which also matches the browser's default line box for the
// preview title. Preview renders the title in a free-flowing box, so both surfaces grow downward
// from SLIDE_TITLE_TOP_IN at this rate rather than being clipped to SLIDE_TITLE_HEIGHT_IN.
export const SLIDE_TITLE_LINE_HEIGHT_MULTIPLE = 1.2;

/**
 * Bottom of the measured title text. The grid starts at this bound or the format's
 * top content bound, whichever is lower on the slide. The title can grow below its
 * fixed export box, so the box height alone does not provide enough clearance.
 *
 * Falls back to the reserved box bottom when the line count is unknown.
 */
export const getSlideTitleBottomIn = ({
  lineCount,
}: {
  lineCount?: number | null;
}): number => {
  if (!lineCount || lineCount < 1) {
    return SLIDE_TITLE_BOTTOM_IN;
  }

  const lineHeightIn = SLIDE_TITLE_FONT_SIZE_PT * SLIDE_TITLE_LINE_HEIGHT_MULTIPLE * PT_TO_IN;

  return SLIDE_TITLE_TOP_IN + (Math.floor(lineCount) * lineHeightIn);
};
export const MAX_FIT_LABEL_LINES = 4;

export class CredentialLayoutError extends Error {
  constructor() {
    super("The slide title leaves too little space for this layout. Use a shorter title.");
    this.name = "CredentialLayoutError";
  }
}

export const FOOTER_CLEARANCE_PT = 10;
export const RRA_FOOTER_LOGO_TOP_IN = 8.3228346;
export const FOOTER_CONTENT_END_IN = RRA_FOOTER_LOGO_TOP_IN - (FOOTER_CLEARANCE_PT * PT_TO_IN);

export type CredGridFormat = "A" | "B" | "C" | "D" | "E" | "F" | "G";
export type TileRowAlignment = "left" | "center";

export type CredGridLayout = {
  format: CredGridFormat;
  rows: number;
  columns: number;
  labelFontSizePt: number;
  logoLabelGapIn: number;
  maxLogoWidthRatio: number;
  /** Default when label measurements are not available. This is not the fit limit. */
  maxLabelLines: number;
  /** Label capacity reserved in every row, including empty rows and the last row. */
  spacingLabelLines: number;
  /** Share of spare height assigned to the two outer margins. */
  outerSlackFraction: number;
  targetLogoHeightIn: number;
  columnGapIn: number;
  topContentStartIn: number;
  sideMarginIn: number;
};

export type RectIn = {
  x: number;
  y: number;
  w: number;
  h: number;
};

export type CredentialLayoutTileInput = {
  id: string;
  labelLineCount?: number | null;
  logoAspectRatio?: number | null;
};

export type CredentialLayoutTile = {
  id: string;
  row: number;
  column: number;
  slot: RectIn;
  logo: RectIn;
  label: RectIn;
  labelLineCount: number;
};

export type CredentialLayoutSlide = {
  format: CredGridFormat;
  rows: number;
  columns: number;
  labelWidthIn: number;
  slots: RectIn[];
  tiles: CredentialLayoutTile[];
};
